export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    level: 3,
    children: [
      // {
      //   title: 'Home',
      //   route: 'home',
      //   icon: 'HomeIcon',
      // },
      // {
      //   title: 'Second Page',
      //   route: 'second-page',
      //   icon: 'FileIcon',
      //   acl: {
      //     action: 'read',
      //     resource: 'ACL',
      //   },
      // },
      {
        title: 'Super Admin',
        route: 'superadmin',
        level: 4,
        icon: 'HomeIcon',
      },
      {
        title: 'Admin',
        route: 'admin',
        level: 3,
        icon: 'HomeIcon',
      },
      {
        title: 'Power User',
        route: 'poweruser',
        level: 2,
        icon: 'HomeIcon',
      },
      {
        title: 'Home',
        route: 'dashboard',
        level: 1,
        icon: 'HomeIcon',
      },
    ],
  },
]
